import React from 'react'
import { useFilterStore, useMapStore } from '../../../state-library/src'
import { ESearchLevel } from '../../../types-library/src'
import {
  Autocomplete as AutocompleteComponent,
  GoogleMapsStructuredPlace
} from '@wiggot/autocomplete-places'
import { ILocation } from '../../../state-library/src/stores/filterStore/types'
import { composeClasses } from '@wiggot/utils/src/strings'

interface IAutocomplete {
  placeholder?: string
  iconClassName?: string
  placeholderClassName?: string
  resultContainerClassName?: string
  defaultFieldValue?: string
  valueClassName?: string
  fieldClassName?: string
  itemClassName?: string
  fieldContainerClassName?: string
  enableMyLocation?: boolean
  inlineMyLocation?: boolean
  enableDefaultSearches?: boolean
  enablePopularSearches?: boolean
  enableSavedSearches?: boolean
  containerClassName?: string
  enableAutoFetch?: boolean
  locations?: ILocation[]
  onDeleteLocation?: (id: string) => void
  onSetValues?: ({}: {
    id: string
    latitude: number
    longitude: number
    searchLevel: ESearchLevel
    searchAddress: string
  }) => void
}

const Autocomplete = ({
  placeholder,
  iconClassName,
  placeholderClassName,
  resultContainerClassName,
  defaultFieldValue,
  valueClassName,
  fieldClassName,
  itemClassName,
  fieldContainerClassName,
  enableMyLocation = true,
  inlineMyLocation = false,
  enableDefaultSearches = false,
  enablePopularSearches = false,
  enableSavedSearches = false,
  enableAutoFetch = true,
  onSetValues,
  containerClassName,
  locations,
  onDeleteLocation
}: IAutocomplete) => {
  const {
    locations: locationsStore,
    latitude,
    longitude,
    setSearchAddress,
    setAreaBounds,
    setPamRequestId,
    setLatitude,
    setLongitude,
    setSearchLevel,
    setPriceFrom,
    setPriceTo,
    setLocations
  } = useFilterStore()
  const { setDrawingTool } = useMapStore()

  const setCoordinates = (
    value: GoogleMapsStructuredPlace | undefined
  ): void => {
    const latitude = value?.coordinates?.latitude || 19.4195256
    const longitude = value?.coordinates?.longitude || -99.162549
    if (!enableAutoFetch) {
      onSetValues?.({
        id: `${latitude}${longitude}`,
        latitude,
        longitude,
        searchLevel: (value?.searchLevel as ESearchLevel) || ESearchLevel.STATE,
        searchAddress: value?.fullAddress || ''
      })
      return
    }
    if (!value) {
      setSearchAddress('')
      return
    }
    setAreaBounds([])
    setDrawingTool({
      isActive: false,
      status: undefined
    })
    setPamRequestId(undefined)
    setLocations([
      ...locationsStore,
      {
        id: `${latitude}${longitude}`,
        latitude,
        longitude,
        searchLevel: (value?.searchLevel as ESearchLevel) || ESearchLevel.STATE,
        searchAddress: value?.fullAddress || ''
      }
    ])
    setLatitude(value?.coordinates?.latitude || 0)
    setLongitude(value?.coordinates?.longitude || 0)
    setSearchLevel((value?.searchLevel as ESearchLevel) || undefined)
    setSearchAddress(value?.fullAddress || '')
    setPriceFrom(0)
    setPriceTo(0)
  }

  const onDeleteLocationStore = (id: string) => {
    setLocations(
      locationsStore.filter(
        ({ latitude, longitude }) => `${latitude}${longitude}` !== id
      )
    )
  }
  return (
    <div
      className={composeClasses(
        'flex relative',
        containerClassName ? containerClassName : ''
      )}
    >
      {/* <AutocompleteComponent
        alignIcon="left"
        iconClassName={composeClasses(
          '!text-primary w-6 h-6',
          iconClassName ? iconClassName : ''
        )}
        placeholder={placeholder || 'Ubicación'}
        placeholderClassName={composeClasses(
          '!text-primary text-[14px] pl-2',
          placeholderClassName ? placeholderClassName : ''
        )}
        valueClassName={composeClasses(
          "text-body-l pl-2 !text-primary font-['Red Hat Display']",
          valueClassName ? valueClassName : ''
        )}
        onChange={setCoordinates}
        onDeleteLocation={onDeleteLocation ?? onDeleteLocationStore}
        resultContainerClassName={composeClasses(
          'w-full z-[1]',
          resultContainerClassName ? resultContainerClassName : ''
        )}
        fieldClassName={composeClasses(
          'border-button-primary-disabled border !rounded-lg !py-3 !px-2 !h-[52px]',
          fieldClassName ? fieldClassName : ''
        )}
        defaultFieldValue={defaultFieldValue || ''}
        iconCleanSearch="!text-primary"
        enableMyLocation={enableMyLocation}
        itemClassName={itemClassName || ''}
        fieldContainerClassName={fieldContainerClassName || ''}
        inlineMyLocation={inlineMyLocation}
        enableDefaultSearches={enableDefaultSearches}
        enablePopularSearches={enablePopularSearches}
        enableSavedSearches={enableSavedSearches}
        locations={locations}
      /> */}
      <AutocompleteComponent
        alignIcon="left"
        iconClassName={composeClasses(
          '!text-primary w-6 h-6',
          iconClassName ? iconClassName : ''
        )}
        placeholder={placeholder || 'Ubicación'}
        placeholderClassName={composeClasses(
          '!text-primary text-[14px] pl-2',
          placeholderClassName ? placeholderClassName : ''
        )}
        valueClassName={composeClasses(
          "text-body-l pl-2 !text-primary font-['Red Hat Display']",
          valueClassName ? valueClassName : ''
        )}
        onChange={setCoordinates}
        onDeleteLocation={onDeleteLocation ?? onDeleteLocationStore}
        resultContainerClassName={composeClasses(
          'w-full z-[1]',
          resultContainerClassName ? resultContainerClassName : ''
        )}
        fieldClassName={composeClasses(
          'border-button-primary-disabled border !rounded-lg !py-3 !px-2 !h-[52px]',
          fieldClassName ? fieldClassName : ''
        )}
        defaultFieldValue={defaultFieldValue || ''}
        iconCleanSearch="!text-primary"
        enableMyLocation={enableMyLocation}
        itemClassName={itemClassName || ''}
        fieldContainerClassName={fieldContainerClassName || ''}
        inlineMyLocation={inlineMyLocation}
        enableDefaultSearches={enableDefaultSearches}
        enablePopularSearches={enablePopularSearches}
        enableSavedSearches={enableSavedSearches}
        // @wiggot/autocomplete-places declara su propio ILocation/ESearchLevel
        // (identicos en forma y valores a los de state-library/types-library,
        // pero son declaraciones de enum distintas, asi que TS los trata como
        // tipos nominalmente incompatibles). Se castea a traves del propio
        // tipo del prop para no depender de un import profundo del paquete.
        locations={
          locations as unknown as React.ComponentProps<
            typeof AutocompleteComponent
          >['locations']
        }
      />
    </div>
  )
}

export default Autocomplete
